import React, { useState } from "react";

import ContactRecents from "./ContactRecents";
import ContactHighFrequents from "./ContactHighFrequents";
import ContactLowFrequents from "./ContactLowFrequents";
import ContactReconnects from "./ContactReconnects";
const ContactTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  return (
    <>
      <div className="bg-white rounded-[20px] overflow-hidden shadow-my_contacts_tabs_shadow">
        <div className="flex whitespace-nowrap justify-between overflow-x-auto ">
          <button
            className={`px-2.5  3xl:px-4 w-full py-[18px] 3xl:py-4 font-semibold text-xs 3xl:text-sm outline-none hover:text-primary transition-all duration-300 ease-out hover:bg-light_purple5  ${
              activeTab === 0
                ? "border-b-2 border-primary text-primary bg-light_purple5"
                : "border-b-2 border-light_gray text-gray"
            }`}
            onClick={() => handleTabClick(0)}>
            Recents
          </button>
          <button
            className={`px-2.5  3xl:px-4 w-full py-[18px] font-semibold text-xs 3xl:text-sm outline-none hover:text-primary transition-all duration-300 ease-out hover:bg-light_purple5 ${
              activeTab === 1
                ? "border-b-2 border-primary text-primary bg-light_purple5"
                : "border-b-2 border-light_gray text-gray"
            }`}
            onClick={() => handleTabClick(1)}>
            High Frequent
          </button>
          <button
            className={`px-2.5  3xl:px-4 w-full py-[18px] font-semibold text-xs 3xl:text-sm outline-none hover:text-primary transition-all duration-300 ease-out hover:bg-light_purple5 ${
              activeTab === 2
                ? "border-b-2 border-primary text-primary bg-light_purple5"
                : "border-b-2 border-light_gray text-gray"
            }`}
            onClick={() => handleTabClick(2)}>
            Low Frequent
          </button>
          <button
            className={`px-2.5  3xl:px-4 w-full py-[18px] font-semibold text-xs 3xl:text-sm outline-none hover:text-primary transition-all duration-300 ease-out hover:bg-light_purple5 ${
              activeTab === 3
                ? "border-b-2 border-primary text-primary bg-light_purple5"
                : "border-b-2 border-light_gray text-gray"
            }`}
            onClick={() => handleTabClick(3)}>
            Reconnects
          </button>
        </div>
        {activeTab === 0 && (
          <div className="mt-5">
            <ContactRecents />
          </div>
        )}
        {activeTab === 1 && (
          <div className="mt-5">
            <ContactHighFrequents />
          </div>
        )}
        {activeTab === 2 && (
          <div className="mt-5">
            <ContactLowFrequents />
          </div>
        )}
        {activeTab === 3 && (
          <div className="mt-5">
            <ContactReconnects />
          </div>
        )}
      </div>
    </>
  );
};

export default ContactTabs;
